import Vue from 'vue'

import Qs from 'qs'

class Tariffs {
  async suggest() {
    return await Vue.axios
      .get('app/tariffs/suggest')
  }

  async index({params}) {
    return await Vue.axios
      .get('app/tariffs', {
        params,
        paramsSerializer: (params) => {
          return Qs.stringify(params)
        }
      })
  }

  async create({data}) {
    return await Vue.axios
      .post('app/tariffs', data)
  }

  async read({id}) {
    return await Vue.axios
      .get('app/tariffs/' + id)
  }

  async update({id, data}) {
    return await Vue.axios
      .put('app/tariffs/' + id, data)
  }

  async delete({id}) {
    return await Vue.axios
      .delete('app/tariffs/' + id)
  }
}

const tariffs = new Tariffs()

export default tariffs
